import axios from 'axios'
import {
	Message
} from 'element-ui'
// import { getToken } from '@/utils/auth'
import router from '../router'
import {
	requestUrl
} from '@/config'

// let base_url;
// console.log(baseURL,'baseURL')
// if (process.env.NODE_ENV === 'production') {
//   base_url = baseURL
// } else if (process.env.NODE_ENV === 'development') {
//   base_url = baseURL
// }


// create an axios instance
const service = axios.create({
	baseURL: requestUrl, // api 的 base_url
	timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
	config => {
		// Do something before request is sent
		// if (store.getters.token) {
		//   // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
		//   config.headers['token'] = getToken()
		// }
		// alert('config---'+JSON.stringify(config))

		return config
		
	},
	error => {
		// Do something with request error
		console.log(error) // for debug
		Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	response => {
		if (typeof response.data === 'string') return response
		if (response.data.code != '200') Message({
			message: response.data.msg,
			type: 'error',
			duration: 5 * 1000
		})
		return response
	},
	error => {
		console.log('err' + error)
		Message({
			message: error.msg,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)

export default service